<script setup>
import { WParagraph, WTitle } from '@alice-health/wonderland-vue'
import { computed } from 'vue'
const props = defineProps({
  enforcingSignature: {
    type: Boolean,
    default: false
  }
})
const description = computed(() => {
  return props.enforcingSignature
    ? 'Sua assinatura digital é obrigatória neste documento. Acesse o Bird ID com seus dados para continuar.'
    : 'É necessário fazer a autenticação do seu login no Bird ID para registros com certificado digital.'
})
const title = computed(() => {
  if (props.enforcingSignature) return 'Autenticação necessária'
  return 'Autenticação de assinatura digital'
})
</script>

<template>
  <header>
    <WTitle class="certification-header__title" size="xsmall" variant="heavy">
      {{ title }}
    </WTitle>
    <WParagraph size="large">
      {{ description }}
    </WParagraph>
  </header>
</template>

<style lang="scss" scoped>
.certification-header {
  &__title {
    color: var(--gl-color-shades-gray-100);
    font-size: var(--gl-font-size-md);
    margin-bottom: var(--gl-spacing-02);
  }
}
</style>
